(function() {
    const API_ENDPOINT = '/apps/scribblerApi/v1/scribbler/private/occasions';
    let occasionCache = null;
    let occasionPromise = null;

    window.ScribblerOccasions = {
        loadOccasions: loadOccasions,
        fetchOccasion: fetchOccasions,
        init: initOccasionSelectors
    };

    async function fetchOccasions(id = null, forceReload = false) {
        if (forceReload || !occasionPromise) {
            occasionPromise = (async () => {
                try {
                    const response = await fetch(API_ENDPOINT, {
                        headers: { Accept: 'application/json' }
                    });
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    const data = await response.json();
                    occasionCache = Array.isArray(data?.rows) ? data.rows : [];
                } catch (err) {
                    console.error('Occasions fetch failed:', err);
                    occasionCache = [];
                }
                return occasionCache;
            })();
        }

        const occasions = await occasionPromise;
        return id != null ? occasions.find(o => String(o.id) === String(id)) || null : occasions;
    }

    async function loadOccasions(selectElement, selectedId = null) {
        if (!(selectElement instanceof HTMLSelectElement)) {
            console.error('Invalid select element');
            return;
        }

        try {
            const occasions = await fetchOccasions();
            const fragment = document.createDocumentFragment();
            selectElement.innerHTML = '';

            const placeholder = new Option('Select Occasion', '', !selectedId, !selectedId);
            placeholder.disabled = true;
            fragment.appendChild(placeholder);

            for (const { id, name } of occasions) {
                fragment.appendChild(new Option(name, id, false, String(id) === String(selectedId)));
            }

            selectElement.appendChild(fragment);
        } catch (err) {
            console.error('Error loading occasions:', err);
            selectElement.innerHTML = '<option value="">Error loading occasions</option>';
        }
    }

    function initOccasionSelectors() {
        const occasionSelect = document.getElementById('occasion-select');
        if (!occasionSelect) return;

        loadOccasions(occasionSelect);

        occasionSelect.addEventListener('change', async (e) => {
            const selectedId = e.target.value;
            if (!selectedId) {
                window.DateSelectors?.updateDateSelectors(null, null);
                return;
            }

            try {
                const occasion = await fetchOccasions(selectedId);
                if (occasion && occasion.month && occasion.day) {
                    window.DateSelectors.updateDateSelectors(occasion.month, occasion.day);
                } else {
                    window.DateSelectors.updateDateSelectors(null, null);
                }
            } catch (err) {
                console.error('Occasion update failed:', err);
                window.DateSelectors?.updateDateSelectors(null, null);
            }
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOccasionSelectors);
    } else {
        initOccasionSelectors();
    }
})();
